export class DocumentsFacade {
    constructor(sdk) {
        this.sdk = sdk;
    }
    // Query many documents
    async query(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getDocuments(query);
    }
    async queryWithProof(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getDocumentsWithProofInfo(query);
    }
    async get(contractId, type, documentId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getDocument(contractId, type, documentId);
    }
    async getWithProof(contractId, type, documentId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getDocumentWithProofInfo(contractId, type, documentId);
    }
    async create(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.documentCreate(options);
    }
    async replace(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.documentReplace(options);
    }
    async delete(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.documentDelete(options);
    }
    async transfer(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.documentTransfer(options);
    }
    async purchase(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.documentPurchase(options);
    }
    async setPrice(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.documentSetPrice(options);
    }
}
